import { NavLink, useLocation } from "react-router-dom";
import { useInboxCompose } from "./InboxComposeProvider"
import React, { useEffect, useState } from "react";
import InboxService from "../Services/InboxService";
import TagService from "../Services/TagService";

function InboxSidebar() {

    const { openCompose } = useInboxCompose();
    const location = useLocation();

    const [accounts, setAccounts] = useState([]);
    const [tags, setTags] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [selectedTag, setSelectedTag] = useState('');
    const [lastMessageFromAccount, setLastMessageFromAccount] = useState('');
    const [accountSearch, setAccountSearch] = useState('');

    useEffect(() => {
        getAccountsWithInbox();
        getTags();
    }, [])

    async function getTags() {
        let tags = await TagService.getAllTags();
        setTags(tags);
    }

    useEffect(() => {
        getAccountFromQueryParams();
        getTagFromQueryParams();
        getLastMessageFromAccountFromQueryParams();
    }, [location.search]);

    function getTagFromQueryParams() {
        let params = new URLSearchParams(location.search);
        let tag = params.get('tag') || '';
        setSelectedTag(tag);
    }

    function getAccountFromQueryParams() {
        let params = new URLSearchParams(location.search);
        let account = params.get('account') || '';
        setSelectedAccount(account);
    }

    function getLastMessageFromAccountFromQueryParams() {
        let params = new URLSearchParams(location.search);
        let fromAccount = params.get('last_message_from_account') || '';
        setLastMessageFromAccount(fromAccount);
    }

    async function getAccountsWithInbox() {
        let accounts = await InboxService.getAccountsInInboxWithNames();
        setAccounts(accounts);
    }

    function renderAccounts() {

        const filtered = accounts.filter(({ name }) =>
            name.toLowerCase().includes(accountSearch.toLowerCase())
        );

        return filtered.map(({ name, email }, index) => {
            const searchParams = new URLSearchParams(location.search);
            searchParams.set('account', email); // conservamos los otros, solo cambiamos el de "account"
            const localSearch = searchParams.toString();

            return (
                <NavLink
                    to={`/admin/inbox?${localSearch}`}
                    key={index}
                    className={({ isActive }) => (isActive && selectedAccount === email) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                    aria-current="true">
                    <i className="fa-solid fa-inbox me-2"></i>
                    {name}
                </NavLink>
            )
        });
    }

    function renderTags() {
        return tags.map(({ name, color }, index) => {

            const searchUrl = getSearchUrl({ name: 'tag', value: name });

            return (
                <NavLink
                    to={`/admin/inbox?${searchUrl}`}
                    key={index}
                    className={({ isActive }) => (isActive && selectedTag === name) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                    aria-current="true">
                    <i className="fa-solid fa-tag me-2" style={{ color: color }}></i>
                    {name}
                </NavLink>
            )
        });
    }

    function getSearchUrl({ name, value }) {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set(name, value); // conservamos los otros, solo cambiamos el de "tag"
        return searchParams.toString();
    }

    function renderReadUnreadLinks() {
        let searchUrlRead = getSearchUrl({ name: 'read', value: 'true' });
        let searchUrlUnread = getSearchUrl({ name: 'read', value: 'false' });

        const isReadActive = location.search.includes('read=true');
        const isUnreadActive = location.search.includes('read=false');

        return (<React.Fragment>
            <NavLink
                to={`/admin/inbox?${searchUrlRead}`}
                className={({ isActive }) => (isActive && isReadActive) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                aria-current="true">
                <i className="fa-solid fa-envelope-open me-2"></i>
                Read
            </NavLink>
            <NavLink
                to={`/admin/inbox?${searchUrlUnread}`}
                className={({ isActive }) => (isActive && isUnreadActive) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                aria-current="true">
                <i className="fa-solid fa-envelope me-2"></i>
                Unread
            </NavLink>
        </React.Fragment>)
    }

    function renderLastMessageFromAccountLinks() {
        let searchUrlFromMe = getSearchUrl({ name: 'last_message_from_account', value: 'true' });
        let searchUrlFromOther = getSearchUrl({ name: 'last_message_from_account', value: 'false' });

        const isFromMeActive = location.search.includes('last_message_from_account=true');
        const isFromOtherActive = location.search.includes('last_message_from_account=false');

        return (<React.Fragment>
            <NavLink
                to={`/admin/inbox?${searchUrlFromMe}`}
                className={({ isActive }) => (isActive && isFromMeActive) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                aria-current="true">
                <i className="fa-solid fa-user me-2"></i>
                From me
            </NavLink>
            <NavLink
                to={`/admin/inbox?${searchUrlFromOther}`}
                className={({ isActive }) => (isActive && isFromOtherActive) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                aria-current="true">
                <i className="fa-solid fa-user-group me-2"></i>
                From contact
            </NavLink>
        </React.Fragment>)
    }

    return (
        <div className="inbox-sidebar">

            <button
                onClick={openCompose}
                className="inbox-compose-button my-2">
                <i class="fa-solid fa-pencil me-3"></i>
                Compose
            </button>

            <div className="inbox-sidebar-search-container mt-3">
                <i className="fa-solid fa-magnifying-glass me-2"></i>
                <input
                    type="text"
                    value={accountSearch}
                    onChange={e => setAccountSearch(e.target.value)}
                    className="inbox-sidebar-search-bar"
                    placeholder="Search accounts" />
            </div>

            <div class="list-group fs-13 mt-3">
                <NavLink
                    to={`/admin/inbox`}
                    className={({ isActive }) => (isActive && !selectedAccount) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                    aria-current="true">
                    <i className="fa-solid fa-inbox me-2"></i>
                    Inbox
                </NavLink>
                {renderAccounts()}
            </div>


            <div class="list-group fs-13 mt-3">
                <NavLink
                    to={`/admin/inbox`}
                    className={({ isActive }) => (isActive && !location.search.includes('read=')) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                    aria-current="true">
                    <i className="fa-solid fa-inbox me-2" ></i>
                    All
                </NavLink>
                {renderReadUnreadLinks()}
            </div>

            <div class="list-group fs-13 mt-3">
                <NavLink
                    to={`/admin/inbox`}
                    className={({ isActive }) => (isActive && !location.search.includes('last_message_from_account')) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                    aria-current="true">
                    <i className="fa-solid fa-inbox me-2" ></i>
                    Last Message
                </NavLink>
                {renderLastMessageFromAccountLinks()}
            </div>



            <div class="list-group fs-13 mt-3">
                <NavLink
                    to={`/admin/inbox`}
                    className={({ isActive }) => (isActive && !selectedTag) ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action'}
                    aria-current="true">
                    <i className="fa-solid fa-inbox me-2" ></i>
                    Labels
                </NavLink>
                {renderTags()}
            </div>




        </div>
    )

}

export default InboxSidebar
